import { useRef, useEffect } from "react";
import isEqual from "lodash/isEqual";
/**
 * Memoizes the current version of the deps
 */
const useDeepEqualCompareMemoize = (value: any) => {
  const memo = useRef<any>(undefined);

  if (!isEqual(value, memo.current)) {
    memo.current = value;
  }

  return memo.current;
};

/**
 * This is like `useEffect` but uses a deep equal to do the comparison
 * Always pass dependencies and don't use primitives as dependencies
 */
export const useDeepEqualEffect = (callback: () => void, deps: any) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, useDeepEqualCompareMemoize(deps));
};
